export default __webpack_public_path__ + "static/media/Group 1386.1761196b.svg";